// src/contexts/NotificationContext.js
import React, { createContext, useState, useEffect, useContext } from "react";
import { AuthContext } from "./AuthContext";
import api from "../utils/api";

export const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const { accessToken, user } = useContext(AuthContext);
  const [hasUnread, setHasUnread] = useState(false);

  const checkUnreadNotifications = async () => {
    if (!accessToken && !user) return;
    try {
      const response = await api.get("/notifications/unread-check");
      setHasUnread(response.data.hasUnread);
    } catch (err) {
      console.error("Error updating unread badge:", err);
    }
  };

  useEffect(() => {
    if (accessToken || user) {
      checkUnreadNotifications();
      const interval = setInterval(checkUnreadNotifications, 45000);
      return () => clearInterval(interval);
    }
  }, [accessToken, user]);

  return (
    <NotificationContext.Provider value={{ hasUnread, setHasUnread, checkUnreadNotifications }}>
      {children}
    </NotificationContext.Provider>
  );
}